<template>
    <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M9.95536 11.4026C8.97262 11.9832 8.00225 12 7.89481 12H1.90778C1.34872 12 0.895466 11.5459 0.895466 10.9857C0.895466 10.4254 1.34872 9.97132 1.90778 9.97132H7.88667C7.92716 9.96985 8.47373 9.9441 8.9827 9.62105C9.64138 9.203 9.97533 8.43265 9.97533 7.33142C9.97533 6.22218 9.63608 5.43575 8.96704 4.99392C8.47405 4.66834 7.94828 4.61766 7.86856 4.61172H4.72412V6.28197C4.72412 6.68977 4.48038 7.05794 4.10542 7.21651C3.97841 7.27024 3.84467 7.29631 3.71204 7.29631C3.45315 7.29631 3.19845 7.19682 3.00564 7.00869L0.306108 4.37493C0.110406 4.18399 0 3.92189 0 3.64818C0 3.37446 0.110406 3.1124 0.306108 2.92142L3.00564 0.287619C3.29727 0.00316795 3.73055 -0.0787322 4.10546 0.0798377C4.48042 0.238408 4.72416 0.606542 4.72416 1.01438V2.58316L7.92095 2.58332C8.028 2.58609 8.9948 2.62769 9.97181 3.23012C10.897 3.8006 12 4.97522 12 7.33134C11.9999 9.69796 10.8881 10.8516 9.95536 11.4026Z"
            :fill="customColor"
        />
    </svg>
</template>

<script setup>
    import { DEFAULT_BUTTON_COLOR } from '~/utils/constants';

    defineProps({
        customColor: {
            type: String,
            required: false,
            default: DEFAULT_BUTTON_COLOR
        }
    });
</script>
